import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  // const userId = localStorage.getItem("userId");

  // const handleLogout = () => {
  //   localStorage.removeItem("userId");
  //   navigate("/login");
  // };

  const pages = [
    { label: "Home", path: "/" },
    { label: "Calculations", path: "/second" },

    // ✅ NEW TABS
    { label: "Customer Cost", path: "/customer-cost" },
    { label: "Sales Person Cost", path: "/salesperson-cost" },

    { label: "Orders", path: "/orders" },

    // userId
    // ? { label: "Logout", action: handleLogout }
    // : { label: "Login", path: "/login" },
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          GSM App
        </Typography>

        {pages.map((page) =>
          page.action ? (
            <Button key={page.label} color="inherit" onClick={page.action}>
              {page.label}
            </Button>
          ) : (
            <Button
              key={page.label}
              color="inherit"
              component={Link}
              to={page.path}
            >
              {page.label}
            </Button>
          ),
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
